import siteConfig from '@/config/site';

// APK 下载逻辑复用
export default {
  data() {
    return {
      apk: null,
      from: siteConfig.promotionChannel,
      filename: siteConfig.promotionName,
      selectedLanguage: 'en',
    };
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    getFallbackApk() {
      return process.env.VUE_APP_AEROLINK || process.env.VUE_APP_GBLINK || process.env.VUE_APP_DEFAULT_APK;
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = this.getFallbackApk();
          }
        })
        .catch(() => {
          this.apk = this.getFallbackApk();
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || siteConfig.apkDomain,
          appName: appname || siteConfig.apkAppName,
        })
        .then((res) => {
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk || this.getFallbackApk();
            }
          } else {
            this.apk = this.getFallbackApk();
          }
        })
        .catch(() => {
          this.apk = this.getFallbackApk();
        });
    },
    gotodownload() {
      if (this.apk) {
        this.$global.download(this.apk);
      } else {
        window.location.href = '/download/';
      }
    },
    downloadApk() {
      const apk = this.apk || this.getFallbackApk();
      if (apk) {
        this.$global.download(apk);
      }
    },
  },
};
